import { faqItems } from '@/mocks/home';

export default function FaqSection() {
  return (
    <section id="faq" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1400px] mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-4xl font-heading font-black text-foreground-950 mb-3">
              常见问题
            </h2>
            <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
              关于春色影视，你可能想了解的问题
            </p>
          </div>

          <div className="max-w-3xl mx-auto space-y-4">
            {faqItems.map((item) => (
              <div
                key={item.id}
                className="bg-background-100 rounded-xl border border-background-200/70 overflow-hidden"
              >
                <div className="p-5 md:p-6">
                  <h3 className="text-base font-heading font-bold text-foreground-900 mb-3 flex items-start gap-3">
                    <span className="text-primary-500 flex-shrink-0 mt-0.5">
                      <i className="ri-question-answer-line"></i>
                    </span>
                    {item.question}
                  </h3>
                  <p className="text-sm text-foreground-600 leading-relaxed pl-9">
                    {item.answer}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}